export const GET_ACCESS_START = "GET_ACCESS_START";
export const GET_ACCESS = "GET_ACCESS";
export const GET_ACCESS_ERROR = "GET_ACCESS_ERROR";

export const SELECT_RETAILERS = "SELECT_RETAILERS";
export const SELECT_CATEGORIES = "SELECT_CATEGORIES";
